/* eslint-disable max-len,jsx-a11y/anchor-is-valid */

import PropTypes from 'prop-types'
import { Transition } from '@headlessui/react'
import Infowijs from './Infowijs'
import UserProfile from './UserProfile'
import { XMark } from '../icons'

function Sidebar({
  navigationItems,
  navigationOpen,
  onNavigationClose,
}) {
  return [
  /* Mobile Navigation */
    <div
      key="mobile-nav"
      className="lg:hidden"
    >
      <Transition
        className="fixed inset-0 flex z-40"
        show={navigationOpen}
      >
        <Transition
          show={navigationOpen}
          className="fixed inset-0 font-medium"
          enter="transition-opacity duration-300 ease-linear"
          leave="transition-opacity duration-300 ease-linear"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="absolute inset-0 bg-gray-600 opacity-75" />
        </Transition>

        <Transition
          show={navigationOpen}
          className="relative flex-1 flex flex-col max-w-xs w-full bg-white focus:outline-none z-50"
          enter="transform duration-300 ease-in-out"
          leave="transform duration-300 ease-in-out"
          enterFrom="-translate-x-full"
          enterTo="-translate-x-0"
          leaveFrom="-translate-x-0"
          leaveTo="-translate-x-full"
        >
          <div className="absolute top-0 right-0 -mr-12 pt-2">
            <button
              type="button"
              className="p-2 ml-1 flex items-center justify-center focus:outline-none text-white hover:text-gray-100"
              onClick={onNavigationClose}
            >
              <span className="sr-only">Close navigation</span>
              <XMark className="text-[1.5rem]" />
            </button>
          </div>
          <div className="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
            <div className="flex-shrink-0 flex items-center px-4">
              <Infowijs />
            </div>
            <nav
              aria-label="Sidebar"
              className="mt-8 px-4 space-y-4 flex-1 flex-col flex"
            >
              {navigationItems}
            </nav>
          </div>
          <div className="p-4 border-t border-gray-200">
            <UserProfile />
          </div>
          <div className="flex-shrink-0 w-14" aria-hidden="true" />
        </Transition>
        ,
      </Transition>
    </div>,
    /* Desktop */
    <div className="hidden lg:flex flex-none bg-gray-50" key="desktop-nav">
      <div className="flex flex-col flex-initial h-screen p-9 w-72">
        <div className="mb-9 flex-shrink-0">
          <Infowijs />
        </div>
        <div className="flex-1 flex-col flex space-y-6">
          {navigationItems}
        </div>
        <div className="flex-shrink-0">
          <UserProfile />
        </div>
      </div>
    </div>,
  ]
}

Sidebar.propTypes = {
  navigationItems: PropTypes.arrayOf(PropTypes.node).isRequired,
  navigationOpen: PropTypes.bool,
  onNavigationClose: PropTypes.func,
}

Sidebar.defaultProps = {
  navigationOpen: false,
  onNavigationClose: () => {},
}

export default Sidebar
